import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { injectStore } from "apiInstance";
import authReducer from "appState/auth/authSlice";
import adminReducer from "appState/admin/adminSlice";
import uploadReducer from "appState/upload/uploadSlice";
import projectReducer from "appState/project/projectSlice";
import donationtReducer from "appState/donation/donationSlice";
import transactionReducer from "appState/transaction/transactionSlice";

import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "TrueKeepers",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  upload: uploadReducer,
  project: projectReducer,
  donation: donationtReducer,
  transaction: transactionReducer,
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
injectStore(store);
export const persistor = persistStore(store);
export default store;
